import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/calendars/$calendarId/disconnect")({
  component: lazyRouteComponent(() => import("./+DisconnectConfirm")),
});
